import Shimmer from "../../ui/shimmer/Shimmer";

const OrderSummaryShimmer = () => (
  <>
    <div className="space-y-2 border-b pb-3">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="flex justify-between items-center text-[12px]">
          <div className="flex gap-2 items-center">
            <Shimmer type="image" />
            <Shimmer type="text" />
          </div>
          <Shimmer type="price" />
        </div>
      ))}
    </div>
    {[...Array(3)].map((_, i) => (
      <div
        key={i}
        className="flex items-center justify-between p-2 border-b mb-2"
      >
        <Shimmer type="text" />
        <Shimmer type="price" />
      </div>
    ))}
    <div className="mt-3">
      <Shimmer type="button" />
    </div>
  </>
);
export default OrderSummaryShimmer;